import { get, set } from 'lodash';

const getFieldValues = fields =>
  fields.reduce((acc, field) => {
    if (!field.fieldName && field.disabled) {
      return acc;
    }
    if (
      Array.isArray(field.value) &&
      field.type !== 'select' &&
      field.type !== 'medication'
    ) {
      const complexValues = getFieldValues(field.value);

      Object.keys(complexValues).forEach(key => {
        // TODO: think about it
        const fromViewConverter = get(field, 'converters.fromView');
        const rawValue = complexValues[key];
        const value = fromViewConverter
          ? fromViewConverter(rawValue)
          : rawValue;

        set(acc, key, value);
      });
    } else {
      const fromViewConverter = get(field, 'converters.fromView');
      const value = fromViewConverter
        ? fromViewConverter(field.value)
        : field.value;
      set(acc, field.fieldName, value);
    }

    return acc;
  }, {});

export default getFieldValues;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/getFieldValues.js